import { Dict } from "@/types/generalTypes";

export default function (path: string, params: Dict<any> | null = null) {
  const pArr = [];
  if (params) {
    for (const i in params) {
      if (Array.isArray(params[i])) {
        for (const it of params[i]) {
          pArr.push(i + "[]=" + it);
        }
      } else {
        pArr.push(i + "=" + params[i]);
      }
    }
  }
  pArr.push("apirv=" + Math.floor(Math.random() * 10000));

  const baseUrl = process.env.VUE_APP_API_URL.includes(window.location.hostname) || 
    window.location.hostname.includes('ngrok-free.app') 
    ? ''
    : process.env.VUE_APP_API_URL;

  return baseUrl + "/api/" + path + "?" + pArr.join("&");
}
